<template>
  <div class="wrapper">

    <el-container >
      <el-container
        v-loading="detail_loading"
        element-loading-text="拼命加载中"
        style="position: absolute!important;"
      >

        <el-aside width="257px" >
          <v-side-bar @onSelect="change" style="top: 14px" ></v-side-bar>
        </el-aside>

        <el-main v-loading="loading" element-loading-text="拼命加载中">
          <div class="top_search">
            <el-input placeholder="请输入内容" v-model="keyword" class="input-with-select" @change="searchBtn">
              <el-select v-model="search_type" slot="prepend" placeholder="请选择">
                <el-option label="事件编号" value="dispute_id"></el-option>
                <el-option label="Email" value="email"></el-option>
              </el-select>
              <el-button slot="suffix" icon="el-icon-search" @click="searchBtn"></el-button>
              <el-button slot="append" type="danger" @click="refresh" style="background-color: red!important;color:white;">重置</el-button>

            </el-input>
            <el-button v-if="this.queue_status == 0" type="primary" @click="bath_aggre(0)" style="height: 40px;margin-left: 5px;">批量通过</el-button>
            <el-button v-if="this.queue_status == 0" type="danger" @click="preprocess_refuse(0)" style="height: 40px">批量拒绝</el-button>
          </div>
          <template v-if="!email">
            <div>请选择账号</div>
          </template>
          <template v-else>

            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="changeSelect">
              <el-menu-item index="0">待处理</el-menu-item>
              <el-menu-item index="1">队列处理中</el-menu-item>
              <el-menu-item index="2">处理完成</el-menu-item>
              <el-menu-item index="3">处理失败</el-menu-item>
              <el-menu-item index="4">拒绝</el-menu-item>
              <el-menu-item index="5">撤销</el-menu-item>
            </el-menu>

            <el-table
              :data="tableData"
              style=".width: 100%"
              @selection-change="handleSelectionChange"
              height="79.5%"
              @row-click="checkDispute"
              default-expand-all
            >
              <el-table-column  type="expand" width="100" >
                <template slot-scope="scopes">
                  <el-table
                      :data="[scopes.row]"
                      tooltip-effect="light"
                  >
                    <el-table-column
                        label="创建时间"
                        width="200"
                        align="right">
                      <template slot-scope="scope">
                        {{ $moment(scope.row.created_at).format("YYYY年MM月DD日") }}
                        <br>{{ $moment(scope.row.created_at).format("HH:mm:ss") }}
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="提交类型"
                        width="200"
                        align="right">
                      <template slot-scope="scope">
                        <div v-if=" scope.row.type == 'accept_claim' && !JSON.parse(scope.row.param).accept_claim_type">
                          全额退款<br>金额：{{ scope.row.dispute_list.value }}{{ scope.row.dispute_list.currency_code }}
                        </div>
                        <div v-else-if=" scope.row.type == 'accept_claim' && JSON.parse(scope.row.param).accept_claim_type == 'PARTIAL_REFUND'  ">
                          已经上报过PAYPAL,部分退款<br>金额：{{JSON.parse(scope.row.param).refund_amount.value}}{{JSON.parse(scope.row.param).refund_amount.currency_code}}
                        </div>
                        <div v-else-if=" scope.row.type == 'accept_claim' && JSON.parse(scope.row.param).accept_claim_type == 'REFUND_WITH_RETURN'  ">
                          已经上报过PAYPAL,退货并全额退款<br>金额：{{ scope.row.dispute_list.value }}{{ scope.row.dispute_list.currency_code }}
                        </div>
                        <div v-else-if=" scope.row.type == 'make_offer' && JSON.parse(scope.row.param).offer_type == 'REFUND' && JSON.parse(scope.row.param).offer_amount ">
                          部分退款 <br>金额：{{JSON.parse(scope.row.param).offer_amount.value}}{{JSON.parse(scope.row.param).offer_amount.currency_code}}
                        </div>
                        <div v-else-if=" scope.row.type == 'make_offer' && JSON.parse(scope.row.param).offer_type == 'REFUND_WITH_REPLACEMENT' ">
                          部分退款并换货<br>金额：{{JSON.parse(scope.row.param).offer_amount.value}}{{JSON.parse(scope.row.param).offer_amount.currency_code}}
                        </div>
                        <div v-else-if=" scope.row.type == 'make_offer' && JSON.parse(scope.row.param).offer_type == 'REFUND_WITH_RETURN' && JSON.parse(scope.row.param).offer_amount.value != scope.row.dispute_list.value ">
                          部分退款并退货<br>金额：{{JSON.parse(scope.row.param).offer_amount.value}}{{JSON.parse(scope.row.param).offer_amount.currency_code}}
                        </div>
                        <div v-else-if=" scope.row.type == 'make_offer' && JSON.parse(scope.row.param).offer_type == 'REFUND_WITH_RETURN' && JSON.parse(scope.row.param).offer_amount.value == scope.row.dispute_list.value ">
                          退货并全额退款<br>金额：{{JSON.parse(scope.row.param).offer_amount.value}}{{JSON.parse(scope.row.param).offer_amount.currency_code}}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="留言信息"
                        width="200"
                        align="right">
                      <template slot-scope="scope">
                        <div>{{ JSON.parse(scope.row.param).note}}</div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="预处理状态"
                        width="200"
                        align="right">
                      <template slot-scope="scope">
                        <div v-if="scope.row.queue_status == 0" style="color: black">
                          待处理
                        </div>
                        <div v-else-if="scope.row.queue_status == 1" style="color: yellow">
                          队列处理中
                        </div>
                        <div v-else-if="scope.row.queue_status == 2" style="color: blue">
                          处理完成
                        </div>
                        <div v-else-if="scope.row.queue_status == 3" style="color: red">
                          处理失败
                        </div>
                        <div v-else-if="scope.row.queue_status == 4" style="color: #795da3">
                          拒绝
                        </div>
                        <div v-else-if="scope.row.queue_status == 5" style="color: #df5000">
                          撤销
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        width="200"
                        @click.stop="checkDispute"
                        align="right">
                      <template slot-scope="scope" >
                        <div v-if="scope.row.queue_status == 0" @click.stop>
                          <el-button type="primary" @click.stop @click="preprocess_agree([scope.row.id])">通过</el-button>
                          <el-button type="danger" @click.stop @click="preprocess_refuse([scope.row.id])">拒绝</el-button>
                        </div>
                      </template>
                    </el-table-column>
                </el-table>
                </template>
              </el-table-column>
              <el-table-column
                  type="selection"
                  width="55">
              </el-table-column>
              <el-table-column
                  label="Paypal账号"
                  width="200"
                  align="right">
                <template slot-scope="scope">
                  {{ scope.row.dispute_list.paypal_account }}
                </template>
              </el-table-column>
              <el-table-column
                  label="事件编号"
                  width="180"
                  align="right">
                <template slot-scope="scope">
                  {{ scope.row.dispute_list.dispute_id }}
                </template>
              </el-table-column>
              <el-table-column
                  label="原因"
                  width="200"
                  align="right">
                <template slot-scope="scope">
                  {{ $t( 'disputed_reason.' + scope.row.dispute_list.reason ) }}
                </template>
              </el-table-column>
              <el-table-column
                  label="状态"
                  width="200"
                  align="right">
                <template slot-scope="scope">
                  {{ $t( 'disputed_status.' + commonToUpper(scope.row.dispute_list.status) ) }}
                </template>
              </el-table-column>
              <el-table-column
                  label="金额"
                  width="120"
                  align="right">
                <template slot-scope="scope">
                  <span style="font-weight: bold">$ {{ scope.row.dispute_list.value }}</span>
                  <br>{{ scope.row.dispute_list.currency_code }}
                </template>
              </el-table-column>
              <el-table-column
                  label="开立日期"
                  width="200"
                  align="right">
                <template slot-scope="scope">
                  {{ $moment(scope.row.dispute_list.create_time).format("YYYY年MM月DD日") }}
                  <br>{{ $moment(scope.row.dispute_list.create_time).format("HH:mm:ss") }}
                </template>
              </el-table-column>
              <el-table-column
                  label="最后更新日期"
                  width="200"
                  align="right">
                <template slot-scope="scope">
                  {{ $moment(scope.row.dispute_list.update_time).format("YYYY年MM月DD日") }}
                  <br>{{ $moment(scope.row.dispute_list.update_time).format("HH:mm:ss") }}
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="current_page"
                :page-size="per_page"
                :page-sizes="[10, 30, 50,100]"
                :pager-count="11"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
            <!--详情-->
            <el-dialog
              title="事件详情"
              :visible.sync="dialogVisible"
              width="60%"
              top="5vh">

              <v-pre-detail :queue_status="queue_status" :buyer_email="buyer_email" :detail_id="detail_id" @detailHand="detailHand" @getData="getData" :preprocess_id="preprocess_id" :per_page="per_page"  :email="detail_email" :dispute_id="select_dispute_id" :detail_data="detail_data"  @changeVDetailLoading="changeVDetailLoading">
              </v-pre-detail>
            </el-dialog>



          </template>

        </el-main>
      </el-container>
    </el-container>

  </div>
</template>

<script>
import vSideBar from "./components/SideBar"
import vPreDetail from "./components/PreDetail"
export default {
  name: "Disputes",
  components: {
    // vHeader,
    vSideBar,
    vPreDetail,

  },
  data() {
    return {
      preprocess_id:0,//选中的队列id
      current_page: 1,//当前页
      per_page: 10,//每页数量
      total: 0,//总数

      loading: false,
      tableData: [],

      activeIndex: '0',

      email: 'all',
      next_page_token: '',

      dialogVisible: false,
      select_dispute_id: "",
      detail_loading: false,
      detail_data: {},



      //设置队列状态
      queue_status:0,
      item_ids:[],
      //筛选部分
      search_type: 'dispute_id',
      keyword:'',//搜索关键词
      detail_id:0,
      buyer_email:'',
      detail_email:''
    }
  },
  methods: {
    refresh(){
      this.activeIndex = '0';
      this.queue_status = 0;
      this.keyword = null;
      this.search_type = 'dispute_id';
      this.getData(1,this.per_page);
    },
    searchBtn(){
      if(!this.search_type){
        this.$message('请选择搜索类型');
        return false;
      }
      if (!this.keyword){
        this.$message('请填写搜索关键词');
        return false;
      }
      this.getData(1, this.per_page,true);
    },
    bath_aggre(ids){
      var _this = this;
      if(ids == 0){
        ids = this.item_ids;
      }
      if(ids.length == 0){
        this.$message('请选择要操作的审核记录');
        return false;
      }
      this.$confirm('是否批量通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.preprocess_agree(ids);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消通过'
        });
      });
    },
    //通过预处理
    preprocess_agree(ids){
      var _this = this;
      if(ids == 0){
        ids = _this.item_ids;
      }
      var data = {
        ids:ids.join(',')
      };
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.http.fetchPut(this.api.preprocess_agree, data).then((res) => {
        if(res.data.code == 200){
          setTimeout(() => {
            loading.close();
            this.$message(res.data.msg);
            _this.return_msg = '';
            _this.fileList = [];
            _this.imgList = [];
            _this.email = 'all';
            _this.getData(1,_this.per_page)
          }, 1000);
        }else{
          loading.close();
          this.$message(res.data.msg);
        }
      }).catch(err => {
        this.$message('服务器错误');
        loading.close();
        console.log(err);
      })
    },
    //拒绝预处理
    preprocess_refuse(ids){
      var _this = this;
      if(ids == 0) ids = _this.item_ids;

      //增加备注信息
      this.$prompt('请输入拒绝理由', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        var data = {
          ids:ids.join(','),
          remark:value
        };
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        _this.http.fetchPut(_this.api.preprocess_refuse, data).then((res) => {
          if(res.data.code == 200){
            setTimeout(() => {
              loading.close();
              this.$message(res.data.msg);
              _this.return_msg = '';
              _this.fileList = [];
              _this.imgList = [];
              _this.email = 'all';
              _this.getData(1,_this.per_page)
            }, 1000);
          }else{
            loading.close();
            this.$message(res.data.msg);
          }
        }).catch(err => {
          this.$message('服务器错误');
          loading.close();
          console.log(err);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消操作成功'
        });
      });



    },
    handleSelectionChange(val){
      this.item_ids = [];
      for (let item in val){
        this.item_ids.push(val[item].id);
      }
    },
    //隐藏详情页面
    detailHand(){
      this.dialogVisible =false;
    },
    checkDispute(row) {
      this.preprocess_id = row.id
      this.detail_data = {}
      this.preprocesses = [];
      if (row.preprocesses){
        this.preprocesses = row.preprocesses;
      }
      this.select_dispute_id = row.dispute_list.dispute_id
      let email=row.paypal_account
      this.detail_loading = true
      this.buyer_email = row.buyer_email;
      this.getDetail(email,row.dispute_list.dispute_id,row.dispute_list_id)
      // alert(row.dispute_id)
    },
    getDetail(email,dispute_id,detail_id) {
      this.detail_email = email;
      this.detail_id = detail_id;
      this.http.fetchGet(this.api.dispute_detail, {id:detail_id}).then((res) => {
        let data = res.data
        if (data.code === 200) {
          this.detail_data = data.data

          //获取能提供的证据类型
          this.reason = this.detail_data.reason;
          //获取当前能不能跑makr_offer
          this.api_type_link = 'accept_claim';
          this.otherEvidenceApi = 'other';
          for(var i in data.data.links){
            if(data.data.links[i].rel == 'make_offer'){
              this.api_type_link = 'make_offer';
            }
            if(data.data.links[i].rel == 'provide_supporting_info'){
              //获取其他证明接口地址
              this.otherEvidenceApi = 'provide_supporting_info';
            }
          }
          this.detail_loading = false
          this.dialogVisible = true
        }
      }).catch(err => {
        this.detail_loading = false
        console.log(err)
      })
    },
    changeVDetailLoading(email,dispute_id,detail_id){
      this.getDetail(email,dispute_id,detail_id);
    },

    changeSelect(key) {
      if(key==="0"){
        this.queue_status = 0
      }else if (key === "1") {
        this.queue_status = 1
      } else if (key === "2") {
        this.queue_status = 2
      } else if (key === "3") {
        this.queue_status = 3
      }else if (key === "4") {
        this.queue_status = 4
      }else if (key === "5") {
        this.queue_status = 5
      }

      this.getData(1,this.per_page)
    },

    //分页改变...
    handleCurrentChange(val) {
      // this.current_page=val
      this.getData(val, this.per_page)
    },
    handleSizeChange(val) {

      this.per_page = val;
      //返回第一页
      this.handleCurrentChange(1);
    },

    getData(page,limit,bool = false) {
      this.loading = true

      let param = {
        email: this.email,
        page: page,
        limit: limit,
        queue_status:this.queue_status
      };
      if(bool){
        if(this.search_type == 'dispute_id') {
          param = {
            email: this.email,
            page: page,
            limit: limit,
            queue_status:this.queue_status,
            dispute_id:this.keyword
          };
        }else if(this.search_type == 'email'){
          param = {
            email: this.email,
            page: page,
            limit: limit,
            queue_status:this.queue_status,
            buyer_email:this.keyword
          };
        }else{
          this.loading = false
          this.$message('请选择正确的类型');
        }
      }
      this.http.fetchGet(this.api.preprocess_list, param).then((res) => {

        if (res.data.code === 200) {
          let data = res.data.data
          this.total = data.total;
          this.current_page = data.current_page;
          this.tableData = data.data
          // this.nextPage(data.data.links)
          this.loading = false
        }
      }).catch(err => {
        console.log(err)
      })
    },

    change(index) {
      this.email = index
      this.getData(1,this.per_page)
    },
  },

}
</script>
<style>
.el-dialog__body{
  padding-top: 0!important;
}
.top_search{
  top: 15px;
  position: relative;
  width: 100%;
  z-index: 9;
  height: 60px;
  display: flex;
}
.top_search .el-select .el-input {
  width: 130px;
}
.top_search .el-input__inner{
  width: 98%;
}

.top_search .input-with-select .el-input-group__prepend {
  background-color: #fff;
  width:130px;
}
.top_search .el-input-group{
  width: 50%;
  height: 40px!important;
}
</style>
<style scoped lang="stylus">

@import "~@/assets/css/varibles.styl"

.order-nub >>> .el-collapse-item__header
  color #9a6e3a

.el-container
  height 100%

.el-menu-demo, .el-menu-item
  height 50px


.wrapper >>> .el-table__row {
  cursor pointer
}

.wrapper >>> .el-main {
    padding 0
}
//.el-tabs>>>.el-tabs__content
//.el-tabs>>>.el-tab-pane
//  height 100%

.el-header
  line-height $hdHeight
  height $hdHeight !important
  position relative
  left 0
  right 0
  top 0
  /*padding-bottom: 30px;*/
  -webkit-transition: left .3s ease-in-out
  transition: left .3s ease-in-out
  background: #acaca9
  color #fff
  padding 0

</style>
